import { StyleSheet, Dimensions } from "react-native";
import AppFonts from "./AppFonts";
import AppColors from "./AppColors";
const { height, width } = Dimensions.get("window");

const windowWidth = Dimensions.get("window").width;

const Appstyles = StyleSheet.create({
  //-------Header Selection--------//

  HeaderMain: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: AppColors.brown,

    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 20,
  },
  HeaderSec: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  ArrowImage: { width: 8, height: 15 },
  Arrowstyle: { height: 30, width: 30, justifyContent: "center" },

  HeaderText: {
    color: AppColors.brown1,
    fontFamily: AppFonts.OverpassMedium,
    fontSize: 16,
  },
  rc: {
    flexDirection: "row",
    alignItems: "center",
  },
  VehicleImage: { width: 20, height: 20 },

  BellImage: { width: 16, height: 20, marginLeft: 20 },

  PlusImage: { width: 18, height: 18, marginLeft: 20 },
  PlusImage7: { width: 20, height: 20, marginLeft: 20 },
  Threedot: { width: 16, height: 18, marginLeft: 20 },
  Printer7: { width: 120, height: 32, marginLeft: 20 },
  //----------------Search InPut------------------

  SecMain: { marginHorizontal: 20 },
  //----------------Search InPut ------------------
cateee7:{
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
},

  Searchvi6: {
    flexDirection: "row",
    width: "80%",
    alignItems: "center",
    borderRadius: 8,
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
    borderWidth: 1,
    height: 44,
    borderColor: "#F6EFE9",
  },
  Searchvii6: {
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    borderRadius: 8,
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
    borderWidth: 1,
    height: 44,
    borderColor: "#F6EFE9",
  },
  TextInput7: {
    paddingLeft: 10,

    width: "90%",
    fontSize:12,
    height: 40,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  TextInputr7: {
    paddingLeft: 10,

    //width: "86%",
    fontSize:12,
    
    height: 40,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  ImpoShare7: { width: 22, height: 22 },
  Allvehicke7: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
   
  },
  Allvehickee7: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
    marginTop: 20,
 
  },
  //----------------Search InPut Edit------------------
  SecMain: { marginHorizontal: 20 },
  ThirdView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  dfasafecgf7:{
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom:20,
    marginTop:20
  },

  FourthView: {
    flexDirection: "row",

    width: "90%",
    alignItems: "center",
    borderRadius: 8,

    justifyContent: "space-between",

    backgroundColor: "#ffffff",

    borderWidth: 1,
    height: 44,

    borderColor: "#F6EFE9",
  },
  TextInputSearch: {
    paddingLeft: 10,
    color: AppColors.grey1,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    backgroundColor: "#ffffff",
    width: "90%",
    alignItems: "center",
    justifyContent: "center",
    height: 42,

    borderRadius: 8,
  },
  SearchImageView: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },

  SearchImage: { width: 20, height: 20, marginRight: 10 },
  ims: { width: 25, height: 25 },

  //------ Safearea -----------------
  safespace7: {
    flex: 1,
    backgroundColor: AppColors.white,
    justifyContent: 'space-between',
  },
  safe: { flex: 1, backgroundColor: AppColors.sandal },
  safe7: { flex: 1, backgroundColor: AppColors.white },
  safedown: { marginTop: 20, flex: 1, backgroundColor: AppColors.white },
  //------ marginHorizontal: 20 -----------------
  MarginHor207: { marginHorizontal:20 },
  MarginHor20: {  marginRight: 10,marginLeft:20 },
  MarginHorR20: { marginRight: 20,marginLeft:10 },
  //------------width: "50%" ------
  width50: { width: "50%" },
  //----------flexDirection: "row"
  flexDirection: { flexDirection: "row" },

  //------------Gap View---------
  GapView: {
    backgroundColor: AppColors.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  GapView7: {
    flex: 1,
    marginTop: 20,
    backgroundColor: AppColors.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  Gapsec: {
    marginTop: 20,
    backgroundColor: AppColors.white,
  },
  Gapsecc7: {
    backgroundColor: AppColors.white,
  },
  //-------------{ marginTop: 20 }

  mm7: { marginHorizontal: 20, marginTop: 15 },
  //-------------------Rahil--------

  //--------Margin-------
  marginTopR: { marginTop: 20 },
  marginTop107: { marginTop: 10 },
  margintopbottom:{marginTop:20,marginBottom:20},

  //-------------------FooterRahil Only ---
  sty7: {
    flexDirection: "row",
    marginVertical: 20,
    // backgroundColor:'red'
  },
  flex7: {
    flex: 1,
   
  },
  LoginWithOtpVw7: {
    
 backgroundColor:'white',
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    //padding: 8,
    width: "100%",
    height: 44,
    //backgroundColor: "red",
  },

  RegisterTxt7: {
    // color: AppColors.brown,
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  //-------------------EmailDetailsR--------
  flexgrow7: { flexGrow: 1 },
  testmess7: {
    color: AppColors.brown,
    fontSize: 14,
    lineHeight: 20,
    fontFamily: AppFonts.OverpassRegular,
  },
  mmar7: { marginTop: 10 },
  fmemail7: { flexDirection: "row", marginTop: 5 },

  emailTev7: {
    color: AppColors.dualbrown,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
  },
  emailTevv7: {
    color: AppColors.dualbrown,
    fontSize: 14,

    fontFamily: AppFonts.OverpassRegular,
  },
  lineEmail7: {
    marginHorizontal: 20,
    alignItems: "center",
    borderColor: AppColors.brown,
    borderWidth: 0.5,
    opacity: 0.099,
    marginTop: 15,
    marginBottom: 15,
  },
  subEmaul7: {
    color: AppColors.brown,
    fontSize: 12,
    marginLeft: 10,
    fontFamily: AppFonts.OverpassSemiBold,
  },
  sec7: { backgroundColor: AppColors.sandal, flex: 1 },
  textts7: {
    color: AppColors.brown1,
    fontSize: 18,

    fontFamily: AppFonts.OverpassSemiBold,
  },
  bmf7: {
    backgroundColor: AppColors.white,
    marginTop: 20,
    flex: 1,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },

  //------------EmailCommunication---------------

  SecMainsd7: { marginHorizontal: 20, backgroundColor: AppColors.white },
  justt: { justifyContent: "center" },

  containerDropdown: {
    marginHorizontal: 20,
    backgroundColor: AppColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: AppColors.white1,
    marginTop: 15,
    height: 44,
    justifyContent: "center",
  },
  containerDropdown7: {
    marginHorizontal: 20,
    backgroundColor: AppColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: AppColors.sandal,
    marginTop: 5,
    height: 44,
    justifyContent: "center",
  },

  icon: {
    height: 12,
    width: 15,
    marginRight: 10,
  },
  itemTextStyle: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },
  placeholderStyle: {
    fontSize: 14,
    fontFamily: AppFonts.ProximaRegular,
    color: AppColors.brown,
    paddingLeft: 10,
  },
  placeholderStylee7: {
    fontSize: 12,
    fontFamily: AppFonts.ProximaRegular,
    color: AppColors.dualbrown,
    paddingLeft: 10,
  },
  selectedTextStyle: {
    fontSize: 14,
    fontFamily: AppFonts.ProximaRegular,
    color: AppColors.brown,
    paddingLeft: 10,
    alignItems: "center",
    fontFamily: AppFonts.BarlowMedium,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,

    alignItems: "center",
    justifyContent: "center",
  },
  containerStyle: {
    borderRadius: 10,
    borderWidth: 5,
    paddingVertical: 5,
    top: 5,
    borderColor: "white",
    backgroundColor: "white",
  },
  rs: {
    flexDirection: "row",

    justifyContent: "space-between",
  },
  LineR: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
    marginTop: 20,
  },
  LineR7: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
    marginTop: 10,
  },
  ThirdvR: {
    marginHorizontal: 20,
    marginBottom: 10,
  },

  DataR: { marginTop: 10, flexDirection: "row" },
  ViR: { flexDirection: "row", marginBottom: 10 },

  Flatmain: {
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 15,
  },
  FlatmainSec: {
    marginLeft: 10,
    paddingHorizontal: 10,
    marginTop: 20,
  },
  FlatTxtSec: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassSemiBold,
    color: AppColors.brown,
  },
  Textt: {
    marginTop: 3,
    fontSize: 12,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Textt1: {
    fontSize: 14,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
  },

  //----------------Announcement------------------
  FlatmainSecAnno7: {
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  MB7: {
    marginTop: 20,
    backgroundColor: AppColors.white,
  },
  SecMainAnno7: { marginHorizontal: 20, marginTop: 20, marginBottom: 20 },

  Anno7: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  imgAnoo7: { width: 55, height: 55 },
  FlatTxt7: { justifyContent: "center", marginLeft: 40 },
  FlatTxtSec7: {
    // marginTop: 5,
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  CopyTextSee7: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  iamge7: { width: 22, height: 22, alignItems: "center" },
  lineanoo7: { borderWidth: 0.5, borderColor: AppColors.grey, opacity: 0.2 },

  mmAnno7: {
    marginHorizontal: 20,
    marginBottom: 10,
  },
  margintop157: { marginTop: 15 },

  viewAudioni7: { width: width * 0.78, height: 55 },
  TexttAno7: {
    marginTop: 3,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  CopyTextSecAnoo7: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  feed7: { backgroundColor: AppColors.ModalColor, flex: 1,
   },
  hshAno7: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },

  viwwModal7: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 14,
    borderTopLeftRadius: 14,
    position: "absolute",
    bottom: 0,
    
  },
  marginTopR7: { marginTop: 20, marginHorizontal: 20 },
  TouchAdd7: { justifyContent: "center", alignItems: "center", marginTop: 20 },
  jnsAno7: { width: "15%", height: 3 },
  fffsfAno7: {
    marginTop: 10,
    flexDirection: "row",
    
  },
  yoooAno7: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt22Ano7: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.dualbrown,
  },
  modoModal7: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown,
  },

  presse7: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd7: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },

  sssAno7: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd7: { alignItems: "center" },
  hbhAno7: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsjcross7: { width: 12, height: 12, alignItems: "center" },
  linsModal7: {
    borderTopWidth: 1,
    marginHorizontal: 20,
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 15,
  },
  fasfdmodal7: { marginTop: 20, marginHorizontal: 20 },
  sdsdsmodal7: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },

  mmmmodal7: {
    flexDirection: "row",
    alignSelf: "flex-end",
    marginHorizontal: 10,
  },
  hoxmodal7: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  LoginWithOtpVwAno7: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  presssAnoo7: {
    width: "40%",
    marginHorizontal: 10,
  },

  //------------------Add Announce----------------

  ScrollAdd7: { marginHorizontal: 0, marginTop: 20 },

  JAAdd7: { justifyContent: "center", alignItems: "center" },
  HEad7: {
    color: AppColors.brown1,
    fontSize: 18,

    fontFamily: AppFonts.OverpassSemiBold,
  },
  lineAdd7: {
    width: "88%",
    alignSelf: "center",
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
    marginBottom: 20,
  },
  addv7: { marginHorizontal: 20, marginTop: 20 },

  Audio7: {
    fontSize: 14,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  reddot7: {
    fontSize: 14,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.red,
    marginLeft: 5,
  },
  //----------- Vehicle -----------------------

  scrollVehicle7: { paddingRight: 20 },

  MainContainervehicle7: {
    flexDirection: "row",
    paddingTop: 15,
    paddingBottom: 15,
    marginHorizontal: -8,

    // backgroundColor: 'yellow',
  },

  toVehi7: { marginLeft: 20 },

  VehicleSelectorveh7: {
    width: width * 0.32,
    // backgroundColor: 'green',
    height: height * 0.052,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    marginHorizontal: 8,
    shadowColor: "#9C4900",
    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 15,
  },

  VehicleSelectorTextVeh7: { fontSize: 12 },
  SearchstyleVeh7: {
    backgroundColor: "white",
    width: "100%",
    // marginTop: 20

    flexGrow: 170,
  },

  tabveh7: { backgroundColor: AppColors.brown },

  tabeveh7: { width: 155, marginRight: 25 },

  //------------Addvehicle----------------------

  bottomAdd7: { bottom: 8, },
  Labelrendeer7: {
    marginHorizontal: 20,
    alignContent: "flex-end",
    justifyContent: "flex-end",
  },

  Addvehicleee7: { alignItems: "flex-end", marginHorizontal: 20 },
  ViewwdAdd7: {
    backgroundColor: AppColors.sandal,
    width: "100%",
    padding: 20,
    borderBottomLeftRadius: 15,
    borderBottomWidth: 1.5,
    borderBottomRightRadius: 15,
    borderBottomColor: AppColors.brown,
  },

  simpAddveh7: {
    justifyContent: "center",
  },
  Addvech7: { marginTop: 20,marginBottom:-20 },

  vehicklecaoac7: {
    marginHorizontal: 20,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  TextAdd7: {
    color: AppColors.brown1,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
  },
  buttonadd7: {
    flexDirection: "row",
    marginVertical: 20,
    //backgroundColor:'white'
    
    
  },
  flexAdd7: {
    flex: 1,
 
  },
  SecMainAddveh7: { marginHorizontal: 20, backgroundColor: AppColors.white },
  TxtstAdd7: {
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassBold,
    fontSize: 18,
  },

  containerAddvec7: {
    flex: 1,
    justifyContent: "center",
    paddingBottom: 20,
    marginHorizontal: 20,
  },
  imgggaddvec7: { width: 18, height: 18 },
  TextListaddvec7: {
    marginLeft: 10,
    color: AppColors.brown,
  },
  hoxAdd7: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  pressAdd7: {
    width: "30%",
    marginHorizontal: 20,
  },

  moadAdd7: { backgroundColor: AppColors.ModalColor, flex: 1 },
  //--------------PaymentInvoice--------------------
  paymentdfgdf7: {
    marginTop: 30,
    backgroundColor: AppColors.white,
    paddingTop: 10,
  },
  jsma7: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 10,
    marginBottom: 20,
  },
  paydas7: {
    alignItems: "flex-end",

    justifyContent: "center",

    flex: 1,
  },

  FlatmainPayment7: {
    //marginTop: 10,
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSecPay7: {
    // margin: 10,
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  imginovicePay7: { width: 55, height: 55 },
  FlatTxtPayy7: { justifyContent: "center", marginLeft: 20 },
  FlatTxtSeccc7: {
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  CopyTextSess7: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  lineeedss7: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
  },
  fllmmpay7: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    marginBottom: 10,
  },
  mmargin7: { marginTop: 10 },

  CopyTextSecd7: {
    width: "100%",
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSed7: {
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  NonCopyd7: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 2,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Texttp7: {
    width: "100%",
    marginTop: 3,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },

  imagepay7: {
    marginBottom: 4,
    justifyContent: "flex-end",
  },
  invoicepay7: {
    width: 120,
    height: 120,
  },

  //--------------InvoiceDetailsss--------------------
  viewstyijnnvo7: {
    marginHorizontal: 20,
    marginTop: 25,
    borderBottomColor: AppColors.sandal,
    borderLeftColor: AppColors.sandal,
    borderTopColor: AppColors.sandal,
    borderWidth: 0.5,
    marginVertical: 2,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderColor: AppColors.sandal,
  },
  dsdinvo7: {
    backgroundColor: AppColors.dualbrown,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    paddingVertical: 20,
  },
  fsfsfcing7: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  white3einbh7: {
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 24,
    color: AppColors.darkbrown,
    width: "50%",
  },
  endssa7: { alignItems: "flex-end" },
  fleds7: { flexDirection: "row", alignItems: "center" },
  te7: {
    fontFamily: AppFonts.OverpassMedium,
    fontSize: 12,
    color: AppColors.brown,
    marginRight: 5,
  },
  texx7: {
    fontFamily: AppFonts.OverpassMedium,
    fontSize: 12,
    color: AppColors.darkbrown,
  },
  tevieww7: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 2,
  },
  howw7: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    marginTop: 20,
  },
  toto7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    fontSize: 11,
  },
  bamee7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    marginTop: 3,
  },
  hdhdy7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    width: width * 0.32,
  },
  Emailll7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
  },
  gstt7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    fontSize: 11,
    marginTop: 3,
  },

  algnTex7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    fontSize: 11,
    textAlign: "right",
  },
  namealn7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    marginTop: 3,
    textAlign: "right",
  },
  contrynam7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    // width: width * 0.30,
    width: width * 0.3,
    textAlign: "right",
  },
  phmno7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    textAlign: "right",
  },
  contrynam07: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 11,
    // width: width * 0.30,
    width: width * 0.32,
    textAlign: "right",
  },
  gstnametect7: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
    fontSize: 11,
    marginTop: 3,
    textAlign: "right",
  },
  dsdsPR7: { width: "8%" },

  nextsec7: {
    marginTop: 20,
    backgroundColor: AppColors.dualbrown,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    paddingVertical: 20,
  },
  paymentredsd7: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginHorizontal: 20,
  },
  rerrr7: {
    flex: 1,

    flexDirection: "row",

    alignItems: "center",
    marginHorizontal: 20,
  },
  dioj7: { width: "5%", alignItems: "flex-start" },
  tedg7: {
    color: AppColors.darkbrown,
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 11,
  },
  flexfefe7: { width: "23%", alignItems: "flex-start" },
  qtyrf7: { width: "12%", alignItems: "flex-start" },

  qtyrpay7: { width: "12%", alignItems: "flex-start" },
  asddsdPaid7: { width: "19%", alignItems: "center" },
  qtyrAmt7: { width: "15%", alignItems: "center" },
  qtyr17: { width: "10%", alignItems: "flex-end" },
  hjsdsajk7: { width: "14%", alignItems: "center" },
  taxamta7: { width: "22%", alignItems: "flex-end" },
  jabjkhjkas7: { width: "12%", alignItems: "center" },
  jsjiwdnj7: { width: "18%", alignItems: "center" },
  police7: { width: "10%" },
  ewewe7: {
    flexDirection: "row",

    alignItems: "center",
    marginHorizontal: 20,
    marginTop: 15,
    marginBottom: 10,
  },
  jkwiwb7: { width: "18%" },
  numraa7: {
    color: AppColors.Black,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 11,
  },
  serr7: {
    color: AppColors.dualbrown,
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 11,
  },
  leoo7: {
    alignItems: "flex-end",
    borderTopWidth: 1,
    borderTopColor: AppColors.sandal,
  },
  ggg7: {
    width: "70%",

    backgroundColor: AppColors.dualbrown,
    paddingVertical: 10,
  },
  hordd7: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  text127: {
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 12,
    color: AppColors.darkbrown,
  },
  kkhkk7: {
    marginTop: 20,
    flexDirection: "row",
    alignItems: "flex-end",
    width: "100%",
  },
  letbrkk7: {
    flexDirection: "row",
    alignItems: "center",
    width: "35%",
    marginLeft: 20,
  },
  vikrm7: {
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 16,
    color: AppColors.brown,
  },
  linedd7: {
    height: 8,
    borderTopWidth: 0.5,
    borderTopColor: AppColors.sandal,

    width: "60%",
  },
  redesrr7: {
    backgroundColor: AppColors.dualbrown,
    paddingVertical: 15,
    marginTop: 20,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  ffff7: {
    flexDirection: "row",
    justifyContent: "space-between",

    marginHorizontal: 20,
    alignItems: "center",
  },
  gfgfg7: {
    borderBottomWidth: 0.5,
    borderBottomColor: AppColors.sandal,
  },
  fstvalue7: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    marginTop: 15,
    marginBottom: 15,

    alignItems: "center",
  },
  hoii7: { marginHorizontal: 20, marginTop: 10 },
  uppum7: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 16,
    color: AppColors.brown,
  },
  mulak7: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 12,
    color: AppColors.brown,
    marginTop: 5,
    marginBottom: 20,
  },
  totalr7: {
    flexDirection: "row",
    // justifyContent: "space-between",
    marginHorizontal: 20,
    marginTop: 10,
    marginBottom: 10,
    // alignItems: "center",
  },
  ffsff7: {
    borderBottomColor: AppColors.sandal,
    borderTopColor: AppColors.sandal,
    borderBottomWidth: 0.5,
    borderTopWidth: 0.5,
  },
  //-------paid--------
  modowed7: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  ttxtpoibvpaid7: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.dualbrown,
  },
  yooosdpaid7: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  fffsfsadsPaid: {
    marginTop: 5,
    flexDirection: "row",
  },
  jnspaocp7: { width: "15%", height: 2 },
  hshppaidg7: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 20,
  },
  viwwPaidiiii7: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  pressePaidModal: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  CopyText1paid7: {
    fontSize: 14,
    marginTop: 2,

    alignItems: "center",
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec17: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
    alignItems: "center",
  },
  CopyTextSecPaid7: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  NonCopyPaid7: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  TextTwoss7: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Texttsdasd7: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  fullygf7: { marginTop: 10, marginHorizontal: 20, marginBottom: 10 },
  iamgerr7: { width: 22, height: 22, alignItems: "center" },
  CopyTextSeefer7: {
    fontSize: 14,
    marginTop: 3,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  FlatTxtSeccD7: {
    // marginTop: 5,
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  FlatTxtff7: { justifyContent: "center", marginLeft: 20 },
  paisd7: { width: 50, height: 50 },
  FlatImgPaid7: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatmainSecPaid7: {
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatmainPaid7: {
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  AsddwPaid7: { marginTop: 20, marginBottom: 20 },
  AsddwPaids7: { marginTop: 20, marginBottom: 20, marginHorizontal: 20 },
  SecMainPaid7: { marginHorizontal: 20, backgroundColor: AppColors.white },
  //------------AllCategory----------------------
  parking7:{
    marginHorizontal: 20,
    marginTop: 20,
    marginBottom: 5,
  },
  SecMainnn7: { marginHorizontal: 20, backgroundColor: AppColors.white },
  backgrnd7:{ backgroundColor: AppColors.white },
  viewofview7:{
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 20,
    marginBottom:20,
    marginTop:20
  },
  
  
  
  
  //------------VehicleView----------------------

  rightName67: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  email67: {
    width: "94%",
    color: AppColors.brown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassRegular,
  },
  answr67: {
    width: "40%",
    color: AppColors.brown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassBold,
    marginLeft: 10,
  },
  singlecard67: {
    marginHorizontal: 20,
    marginBottom: 20,
    borderRadius: 10,
    borderWidth: 0.5,
    borderColor: AppColors.sandal,
    paddingBottom: 20,
  },
  cardwidthview67: {
    // backgroundColor: AppColors.sandal,
    // backgroundColor:'aqua',
    // flexDirection:'row',
    // justifyContent:'space-between',
    borderRadius: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: AppColors.sandal,
  },
  cardwidthtext67: {
    fontSize: 18,
    color: AppColors.brown1,
    fontFamily: AppFonts.OverpassSemiBold,
    padding: 20,
  },
  colunSty67: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "60%",
  },
  manager67: {
    width: "40%",
    color: AppColors.brown,
    fontSize: 14,
    fontFamily: AppFonts.OverpassMedium,
  },
 



  //----------------------------------

  LoginContainer: {
    flex: 1,
    backgroundColor: "#F6EFE9",
    justifyContent: "space-between",
  },
  VehicleLoginImage: {
    width: "100%",
    height: windowWidth * 0.75,
    resizeMode: "stretch",
  },
  VehicleLogo: {
    alignSelf: "center",
    width: windowWidth * 0.55,
    height: 76,
    marginTop: 15,
    resizeMode: "contain",
  },
  EmailidTxt: {
    color: AppColors.brown1,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
   //lineHeight: 24,
    // marginLeft: 20,
    // marginTop:14
    // backgroundColor:"blue"
  },
  EmailTextinput: {
    borderColor: "#F6EFE9",
    borderWidth: 1,
    // alignItems: "center",
    borderRadius: 8,
    paddingHorizontal: 12,
    //paddingVertical: 5,
    marginTop: 7,
    // paddingTop: 7,
    // paddingBottom: 1,
    // height: 40,
    marginHorizontal: 20,
    fontFamily: AppFonts.OverpassRegular,
    color: "#8F4300",
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    // justifyContent:"center",
    //backgroundColor:"pink",
    //alignContent:"center",
    paddingVertical: 8,
  },
  ForgotPassTxt: {
    color: "#8F430080",
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
    lineHeight: 24,
    marginRight: 20,
    alignSelf: "flex-end",
  },
  LoginButton: {
    // borderColor: "#ACACAC",
    // borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    // marginBottom:40,
    //height: 40,
    margin: 20,
    backgroundColor: AppColors.brown,
    //
  },

  LoginTxt: {
    color: "#F6EFE9",
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 18,
    // letterSpacing: 0.56,
    //lineHeight: 24,
    //  marginLeft: 20,
    paddingVertical: 8,
  },
  LoginWithOtpVw: {
    borderColor: AppColors.brown1,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,

    // height: 40,
    marginHorizontal: 0,
    marginBottom: 40,

    flex: 1,
  },
  RegisterTxt: {
    color: AppColors.brown1,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
    //lineHeight: 24,
    //  marginLeft: 20,
    paddingVertical: 8,
  },
  headerview: {
    width: "100%",

    flexDirection: "row",

    alignItems: "center",

    backgroundColor: "white",

    height: 58,

    justifyContent: "space-between",

    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 10, height: 1 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 10,
  },
  fullAlignment: {
    flexDirection: "row",

    justifyContent: "space-between",

    alignItems: "center",
  },
  goback: {
    height: 30,
    width: 30,
    justifyContent: "center",
    backgroundColor: "white",
  },
  blurmap: {
    width: "100%",
    height: "100%",
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
  },
  upwhiteview: {
    flex: 1,
    backgroundColor: AppColors.white,
    marginHorizontal: 20,
    zIndex: 100,
    marginTop: -150,
    marginBottom: 20,
    borderRadius: 15,
  },
  whiteAlign: {
    flexDirection: "row",
    justifyContent: "space-between",
    //flex: 1,
    marginHorizontal: 10,
    backgroundColor: "white",
  },
  seleCard: {
    width: width * 0.36,
    alignItems: "center",
    backgroundColor: AppColors.sandal,
    // flex:1,
    marginBottom: 20,
    borderRadius: 8,
    justifyContent: "center",
    height: height * 0.22,
    paddingVertical: 20,
    
  },
  cardImg: {
    width: 40,
    height: 40,
    marginBottom: 20,
  },
  cardText: {
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown,
    fontSize: 14,
    textAlign: "center",
    width: "70%",
  },
  notselView: {
    width: width * 0.36,
    height: height * 0.22,
    paddingVertical: 20,
    alignItems: "center",
    borderColor: AppColors.brown,
    borderWidth: 1,
    marginBottom: 20,
    borderRadius: 10,
    justifyContent: "center",
    backgroundColor: AppColors.white,
   
  },
  seleText: {
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown,
    fontSize: 14,
    textAlign: "center",
    
  },
  NoseleText: {
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown,
    fontSize: 14,
    textAlign: "center",
    
  },
});

export default Appstyles;
